import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form"];

  updatePassword(event) {
    event.preventDefault();
    const form = this.formTarget;
    const redirectUrl = this.data.get("redirectUrl");

    axios
      .patch(form.action, $(form).serialize())
      .then(response => {
        $(".card.card-signup").addClass("hidden");
        bootbox.alert({
          message:
            "Your password has been reset, please login with your new password",
          callback: function () {
            window.location = redirectUrl;
          },
          closeButton: false
        });
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }
}
